import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FieldError } from '../../../avisDePub/creer/services/field-error';
import { StepperBuilderService } from '../../../avisDePub/creer/services/stepper.builder.service';
import { FormulaireServiceService } from '../../../formulaires/services/formulaire-service.service';
import { ErreurMessages } from '../../models/component-messages/erreur-messages';

@Component({
  selector: 'app-eform-error-no-clikable',
  templateUrl: './eform-error-no-clikable.component.html',
  styleUrls: ['./eform-error-no-clikable.component.scss']
})
export class EformErrorNoClikableComponent implements OnInit, OnChanges {

  @Input() stepid;
  @Input() linkForRouter: string;
  public erreurMessages = new ErreurMessages();

  errors: BehaviorSubject<Array<FieldError>> = new BehaviorSubject([]);
  errorLength = 0;

  constructor(public stepBuilder: StepperBuilderService, private formulaireService: FormulaireServiceService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["stepid"]) {
      this.formulaireService.formulaireResponse.emit();
    }
  }

  ngOnInit(): void {
    this.formulaireService.formulaireResponse.subscribe(
      next => {
        this.updateErrors();
      }
    );

    // S'abonner aussi à newError pour être notifié immédiatement quand une erreur est ajoutée
    this.stepBuilder.newError.subscribe((val) => {
      if (val) {
        this.updateErrors();
      }
    });
  }

  private updateErrors(): void {
    const size = this.stepBuilder.getStepFieldsOnErrorsWithoutLocation().size;
    let errors = [];
    if (size) {
      errors = Array.from(this.stepBuilder.getStepFieldsOnErrorsWithoutLocation());
    }
    this.errors.next(errors);
    this.errorLength = errors.length;
  }
}
